"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert = exports.description = exports.name = exports.id = void 0;
exports.id = 'postman-environment';
exports.name = 'Postman Environment';
exports.description = 'Importer for Postman environments';
const convert = rawData => {
    try {
        const { _postman_variable_scope, name, values } = JSON.parse(rawData);
        if (_postman_variable_scope !== 'environment') {
            return null;
        }
        return [
            {
                _id: '__ENV_1__',
                _type: 'environment',
                name: name || 'Postman Environment',
                data: values.reduce((accumulator, { enabled, key, value }) => {
                    if (!enabled) {
                        return accumulator;
                    }
                    return {
                        ...accumulator,
                        [key]: value,
                    };
                }, {}),
            },
        ];
    }
    catch (error) {
        // Nothing
    }
    return null;
};
exports.convert = convert;
//# sourceMappingURL=postman-env.js.map